import {ElementDto} from "../../../../../common/apis/element/ElementDto";
import {ElementDataDto, GraphDataDto, RelationshipDataDto} from "../../../../../common/apis/GraphApiClient";
import {ReferenceDefinitionDto, ReferenceElementFilterDto, RelationshipDirection} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";

export interface RelationshipDetail {
    relationship: RelationshipDataDto;
    element: ElementDto;
}

export default class ReferenceDefinitionGraphSearcher {

    private constructor() {
    }

    static findRelatedElementsByReferenceDefinition(initialElement: ElementDto, definition: ReferenceDefinitionDto, graph: GraphDataDto): RelationshipDetail[] {
        const matchedRelationships = graph.relationshipsData
                .filter(relationship => ReferenceDefinitionGraphSearcher.checkRelationshipMatchesDefinition(relationship, definition, initialElement.identifier));
        const matchedElements = graph.elementsData
                .filter(element => ReferenceDefinitionGraphSearcher.checkElementMatchesFilter(element, definition.relatedElementFilter));

        const details = matchedRelationships
                .map(relationship => {
                    const elementId = (relationship.sourceIdentifier === initialElement.identifier) ? relationship.targetIdentifier : relationship.sourceIdentifier;
                    const element = matchedElements.find(element => element.id === elementId);
                    if (element) {
                        return ({
                            relationship: relationship,
                            element: ReferenceDefinitionGraphSearcher.convertToElementDto(element)
                        });
                    } else {
                        return null;
                    }
                });

        return details.filter(detail => detail !== null) as RelationshipDetail[];
    }

    private static convertToElementDto(elementData: ElementDataDto): ElementDto {
        return {
            identifier: elementData.id,
            name: elementData.name,
            description: elementData.description,
            type: elementData.type,
            collections: [],
            labels: [],
            acl: {
                canRead: true,
                canUpdate: false,
                canDelete: false,
                canCreateProperty: false,
                canCreateChats: false,
                canCreateAttachment: false,
                canMerge: false,
                canAlterType: false,
                canUpdateCollections: false,
                canUpdatePublicLabels: false,
            }
        };
    }

    static checkRelationshipMatchesDefinition(relationship: RelationshipDataDto, definition: ReferenceDefinitionDto, initialElementIdentifier: string): boolean {
        if (relationship.type !== definition.relationshipType) {
            return false;
        }

        const direction = ReferenceDefinitionGraphSearcher.resolveDirection(relationship, initialElementIdentifier);
        if (direction !== definition.relationshipDirection) {
            return false;
        }

        return true;
    }

    static resolveDirection(relationship: RelationshipDataDto, initialElementIdentifier: string): RelationshipDirection | undefined {
        if (relationship.sourceIdentifier === initialElementIdentifier) {
            return RelationshipDirection.OUTGOING;
        } else if (relationship.targetIdentifier === initialElementIdentifier) {
            return RelationshipDirection.INCOMING;
        } else {
            return undefined;
        }
    }

    static checkElementMatchesFilter(element: ElementDataDto, relatedElementFilter: ReferenceElementFilterDto): boolean {
        if (relatedElementFilter.type && relatedElementFilter.type !== element.type) {
            return false;
        }

        if (relatedElementFilter.stereotypeId && relatedElementFilter.stereotypeId !== element.stereotypeId) {
            return false;
        }

        return true;
    }
}